"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import UserPageSetUpProfile from "./UserPageSetUpProfile";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageSetUpProfileWrapper(t0) {
  const $ = _c(12);
  const {
    profile,
    children
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  let t1;
  if ($[0] !== address || $[1] !== profile) {
    t1 = () => {
      if (!address) {
        return false;
      }
      if (!profile) {
        return false;
      }
      if (profile.handle) {
        return false;
      }
      return !!profile.wallets?.find(w => [w.wallet.toLowerCase(), w.display?.toLowerCase()].includes(address.toLowerCase()));
    };
    $[0] = address;
    $[1] = profile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getShowSetUpProfile = t1;
  const [showSetUpProfile, setShowSetUpProfile] = useState(getShowSetUpProfile());
  let t2;
  if ($[3] !== getShowSetUpProfile) {
    t2 = () => setShowSetUpProfile(getShowSetUpProfile());
    $[3] = getShowSetUpProfile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== address || $[6] !== profile) {
    t3 = [profile, address];
    $[5] = address;
    $[6] = profile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  if (showSetUpProfile) {
    let t4;
    if ($[8] !== profile) {
      t4 = <UserPageSetUpProfile profile={profile} />;
      $[8] = profile;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t4;
  if ($[10] !== children) {
    t4 = <>{children}</>;
    $[10] = children;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}